import gql from 'graphql-tag';

export const WS_ESTIMATED_TIME_UPDATE = gql`
  subscription($appointmentIds: [String!]!) {
    estimatedTimeToBeServedUpdate(appointmentIds: $appointmentIds) {
      appointmentId
      estimatedTimestamp
      displayMessage
      displayStyle {
        color
      }
    }
  }
`;
